import { VApp } from 'vuetify/lib/components/VApp';
import { VChip } from 'vuetify/lib/components/VChip';
import { VChipGroup } from 'vuetify/lib/components/VChipGroup';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _setup.placeTypes.length
    ? _c(
        VApp,
        { attrs: { "data-qa": "doctor-price-block-by-type" } },
        [
          _setup.placeTypes.length > 1
            ? _c(
                VChipGroup,
                {
                  staticClass: "mb-3",
                  attrs: { mandatory: "" },
                  on: { change: _setup.handleChangeActiveType },
                  model: {
                    value: _setup.activeType,
                    callback: function ($$v) {
                      _setup.activeType = $$v
                    },
                    expression: "activeType",
                  },
                },
                _vm._l(_setup.placeTypes, function (placeType) {
                  return _c(
                    VChip,
                    {
                      key: placeType,
                      attrs: {
                        "data-place-type": placeType,
                        value: placeType,
                        color:
                          placeType === _setup.activeType
                            ? "primary"
                            : "bg-primary",
                        "text-color":
                          placeType === _setup.activeType
                            ? "bg-gray-0"
                            : "primary",
                      },
                    },
                    [
                      _vm._v(
                        "\n      " +
                          _vm._s(
                            _setup.t(
                              _setup.CHIP_LABELS[placeType],
                              _setup.options
                            )
                          ) +
                          "\n    "
                      ),
                    ]
                  )
                }),
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(_setup.DoctorPriceBlock, {
            ref: "doctorPriceBlockRef",
            attrs: {
              "page-type": _setup.activeType,
              price: _vm.priceList[_setup.activeType].price,
              "club-price":
                _setup.activeType === "clinic"
                  ? _vm.priceList.clinic.clubPrice
                  : undefined,
              "telemed-medtochka-price":
                _setup.activeType === "telemed"
                  ? _vm.priceList.telemed.medtochkaPrice
                  : undefined,
              "tab-is-free-with-treatment":
                _vm.priceList.clinic.tabIsFreeWithTreatment,
            },
            on: { "update:redirect-value": _setup.handleUpdateRedirectValue },
          }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }